import { STEP_ORDER as S, isStepComplete as U, computeQuote as N, formatCents as I, stepIndexOf as q, STEP_HEADINGS as v, getStepOptions as M, getEffectiveSelection as O, derivedDimensions as G, validateLead as Q, buildQuotePayload as H, mergeConfig as Y, defaultConfig as K, reduce as V, createInitialState as W } from "./core.js";
import { CONFIGURATOR_VERSION as Te, MSG_SELECT_MODEL as Oe, MSG_SELECT_TO_CONTINUE as De, PRICED_STEPS as Pe, STEP_LABELS as qe, basePriceCents as _e, floorSqFt as Ae, getInclusion as Re, includedOptionId as $e, isUpgradeOptionId as Fe, loftPriceCents as je, loftUpgradeDeltaCents as Be, optionPriceCents as Ue, optionTitle as Ge, paintableSqFt as Qe, priceQuote as He, shortestWallFt as Ye, validateSelection as Ke } from "./core.js";
import { jsx as e, jsxs as d, Fragment as u } from "react/jsx-runtime";
import { createContext as Z, useContext as J, useEffect as C, forwardRef as X, useRef as z, useState as _, useMemo as L, useReducer as ee } from "react";
const $ = Z(null);
function b() {
  const t = J($);
  if (!t)
    throw new Error("useConfigurator must be used inside <ShedConfigurator />");
  return t;
}
const te = {
  anchor: "/configurator/anchors/auger.webp",
  blocks: "/configurator/foundation/out-of-level-shed.webp",
  floor: "/configurator/flooring/flooring-0.webp",
  loft: "/configurator/loft/loft.webp",
  none: "/configurator/none/none.png",
  obstruction: "/configurator/Headache.webp",
  ramp: "/configurator/ramp/shed-ramp.webp",
  shelving: "/configurator/shelving/shelving.webp",
  shingles: "/configurator/shingles/3-tab-shingles.webp",
  "shingles-arch": "/configurator/shingles/architectural-shingles.webp",
  solar: "/configurator/venting/solar-vent-fan.webp",
  vent: "/configurator/venting/complete-venting.webp",
  window: "/configurator/window/shed-window.webp",
  workbench: "/configurator/workbench/workbench-1.webp"
}, A = {
  shed: /* @__PURE__ */ d(u, { children: [
    /* @__PURE__ */ e("path", { d: "M4 20h24v14H4z" }),
    /* @__PURE__ */ e("path", { d: "M2 20 16 9l14 11" }),
    /* @__PURE__ */ e("path", { d: "M13 34v-8h6v8" })
  ] }),
  paint: /* @__PURE__ */ d(u, { children: [
    /* @__PURE__ */ e("rect", { x: "6", y: "7", width: "16", height: "8", rx: "1.5" }),
    /* @__PURE__ */ e("path", { d: "M22 10h5v6l-9 4v6" }),
    /* @__PURE__ */ e("rect", { x: "15.5", y: "26", width: "5", height: "8", rx: "1" })
  ] }),
  primer: /* @__PURE__ */ d(u, { children: [
    /* @__PURE__ */ e("path", { d: "M16 7c4 6 7 10 7 14a7 7 0 1 1-14 0c0-4 3-8 7-14Z" }),
    /* @__PURE__ */ e("path", { d: "M12 22a4 4 0 0 0 4 4" })
  ] }),
  none: /* @__PURE__ */ d(u, { children: [
    /* @__PURE__ */ e("circle", { cx: "16", cy: "20", r: "11" }),
    /* @__PURE__ */ e("path", { d: "m8.5 12.5 15 15" })
  ] }),
  floor: /* @__PURE__ */ d(u, { children: [
    /* @__PURE__ */ e("path", { d: "M4 24l12-7 12 7-12 7z" }),
    /* @__PURE__ */ e("path", { d: "M10 20.5l12 7M16 17l12 7" })
  ] }),
  "floor-upgraded": /* @__PURE__ */ d(u, { children: [
    /* @__PURE__ */ e("path", { d: "M4 26l12-7 12 7-12 7z" }),
    /* @__PURE__ */ e("path", { d: "M10 22.5l12 7M16 19l12 7" }),
    /* @__PURE__ */ e("path", { d: "M16 6v8m0-8-3 3m3-3 3 3" })
  ] }),
  level: /* @__PURE__ */ d(u, { children: [
    /* @__PURE__ */ e("rect", { x: "5", y: "17", width: "22", height: "6", rx: "1" }),
    /* @__PURE__ */ e("circle", { cx: "16", cy: "20", r: "1.6" }),
    /* @__PURE__ */ e("path", { d: "M11 20h2M19 20h2" })
  ] }),
  blocks: /* @__PURE__ */ d(u, { children: [
    /* @__PURE__ */ e("rect", { x: "5", y: "12", width: "9", height: "7", rx: "1" }),
    /* @__PURE__ */ e("rect", { x: "18", y: "12", width: "9", height: "7", rx: "1" }),
    /* @__PURE__ */ e("rect", { x: "11.5", y: "21", width: "9", height: "7", rx: "1" })
  ] }),
  anchor: /* @__PURE__ */ d(u, { children: [
    /* @__PURE__ */ e("circle", { cx: "16", cy: "9", r: "3" }),
    /* @__PURE__ */ e("path", { d: "M16 12v16" }),
    /* @__PURE__ */ e("path", { d: "M8 20c0 6 4 8 8 8s8-2 8-8" }),
    /* @__PURE__ */ e("path", { d: "M11 16h10" })
  ] }),
  delivery: /* @__PURE__ */ d(u, { children: [
    /* @__PURE__ */ e("path", { d: "M2 22h13v-9H2zM15 16h7l4 4v2h-11z" }),
    /* @__PURE__ */ e("circle", { cx: "8", cy: "25", r: "2" }),
    /* @__PURE__ */ e("circle", { cx: "21", cy: "25", r: "2" })
  ] }),
  obstruction: /* @__PURE__ */ d(u, { children: [
    /* @__PURE__ */ e("path", { d: "M16 5l11 19H5z" }),
    /* @__PURE__ */ e("path", { d: "M16 13v6" }),
    /* @__PURE__ */ e("circle", { cx: "16", cy: "22", r: "0.6" })
  ] }),
  workbench: /* @__PURE__ */ d(u, { children: [
    /* @__PURE__ */ e("path", { d: "M4 17h24" }),
    /* @__PURE__ */ e("path", { d: "M7 17v12M25 17v12M7 23h18" }),
    /* @__PURE__ */ e("path", { d: "M12 17v-4h8v4" })
  ] }),
  ramp: /* @__PURE__ */ d(u, { children: [
    /* @__PURE__ */ e("path", { d: "M4 28h24" }),
    /* @__PURE__ */ e("path", { d: "M4 28 24 14h4v14" }),
    /* @__PURE__ */ e("path", { d: "M10 23.8l2.5 3.5M16 19.6l2.5 3.5M22 15.4l2.5 3.5" })
  ] }),
  loft: /* @__PURE__ */ d(u, { children: [
    /* @__PURE__ */ e("path", { d: "M3 19 16 8l13 11" }),
    /* @__PURE__ */ e("path", { d: "M8 18v12M24 18v12" }),
    /* @__PURE__ */ e("path", { d: "M8 23h16M13 23v7" })
  ] }),
  shelving: /* @__PURE__ */ d(u, { children: [
    /* @__PURE__ */ e("path", { d: "M6 7v26M26 7v26" }),
    /* @__PURE__ */ e("path", { d: "M6 13h20M6 21h20M6 29h20" }),
    /* @__PURE__ */ e("path", { d: "M10 13v-3h5v3M17 21v-4h6v4" })
  ] }),
  vent: /* @__PURE__ */ d(u, { children: [
    /* @__PURE__ */ e("rect", { x: "6", y: "10", width: "20", height: "20", rx: "2" }),
    /* @__PURE__ */ e("path", { d: "M9 15h14M9 20h14M9 25h14" })
  ] }),
  solar: /* @__PURE__ */ d(u, { children: [
    /* @__PURE__ */ e("circle", { cx: "16", cy: "20", r: "6" }),
    /* @__PURE__ */ e("path", { d: "M16 8v3M16 29v3M28 20h-3M7 20H4M24.5 11.5l-2.1 2.1M9.6 26.4l-2.1 2.1M24.5 28.5l-2.1-2.1M9.6 13.6 7.5 11.5" })
  ] }),
  window: /* @__PURE__ */ d(u, { children: [
    /* @__PURE__ */ e("rect", { x: "8", y: "8", width: "16", height: "24", rx: "1.5" }),
    /* @__PURE__ */ e("path", { d: "M16 8v24M8 20h16" })
  ] }),
  shingles: /* @__PURE__ */ d(u, { children: [
    /* @__PURE__ */ e("path", { d: "M4 14h24M4 21h24M4 28h24" }),
    /* @__PURE__ */ e("path", { d: "M10 14v7M22 14v7M16 21v7" })
  ] }),
  "shingles-arch": /* @__PURE__ */ d(u, { children: [
    /* @__PURE__ */ e("path", { d: "M4 14h24M4 21h24M4 28h24" }),
    /* @__PURE__ */ e("path", { d: "M8 14v7M16 14v7M24 14v7M12 21v7M20 21v7" })
  ] })
};
function F({ kind: t }) {
  const r = te[t];
  return r ? /* @__PURE__ */ e("img", { className: "shdcfg-card-photo", src: r, alt: "", "aria-hidden": "true", loading: "lazy" }) : /* @__PURE__ */ e(
    "svg",
    {
      viewBox: "0 0 32 38",
      width: "44",
      height: "52",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "1.8",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      "aria-hidden": "true",
      children: A[t] ?? A.shed
    }
  );
}
function D() {
  return /* @__PURE__ */ e("svg", { viewBox: "0 0 16 16", fill: "none", "aria-hidden": "true", children: /* @__PURE__ */ e(
    "path",
    {
      d: "m3 8.5 3.5 3.5L13 5",
      stroke: "currentColor",
      strokeWidth: "2.4",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ) });
}
function re() {
  const { state: t, dispatch: r, config: s } = b(), c = S[t.stepIndex], i = U(c, t, s), o = N(t, s);
  return /* @__PURE__ */ d(u, { children: [
    t.advanceError && /* @__PURE__ */ e("p", { className: "shdcfg-error", role: "alert", children: t.advanceError }),
    /* @__PURE__ */ d("div", { className: "shdcfg-nav", children: [
      /* @__PURE__ */ e(
        "button",
        {
          type: "button",
          className: "shdcfg-btn shdcfg-btn-ghost",
          onClick: () => r({ type: "BACK_STEP" }),
          disabled: t.stepIndex === 0,
          children: "Back"
        }
      ),
      /* @__PURE__ */ d("div", { className: "shdcfg-nav-total", children: [
        "Current total",
        /* @__PURE__ */ e("strong", { children: I(o.totalCents) })
      ] }),
      /* @__PURE__ */ e(
        "button",
        {
          type: "button",
          className: "shdcfg-btn shdcfg-btn-primary",
          "aria-disabled": !i,
          onClick: () => r({ type: "ADVANCE_STEP" }),
          children: "Continue"
        }
      )
    ] })
  ] });
}
const se = [
  { label: "Size", steps: ["model"] },
  { label: "Paint", steps: ["paint"] },
  { label: "Roof", steps: ["roofing"] },
  { label: "Flooring", steps: ["flooring", "foundation"] },
  { label: "Options", steps: ["workbench", "loft", "shelving", "venting", "window", "delivery", "anchors", "ramp"] },
  { label: "Quote", steps: ["quote"] }
];
function de() {
  const { state: t } = b(), r = t.stepIndex / (S.length - 1) * 100;
  return /* @__PURE__ */ d("nav", { className: "shdcfg-stepper", "aria-label": "Configuration progress", children: [
    /* @__PURE__ */ e("ol", { className: "shdcfg-stepper-groups", children: se.map((s, c) => {
      const i = q(s.steps[0]), o = q(s.steps[s.steps.length - 1]), a = t.stepIndex >= i && t.stepIndex <= o, h = t.stepIndex > o;
      return /* @__PURE__ */ d(
        "li",
        {
          className: `shdcfg-stepper-group${a ? " is-current" : ""}${h ? " is-done" : ""}`,
          "aria-current": a ? "step" : void 0,
          children: [
            /* @__PURE__ */ e("span", { className: "shdcfg-stepper-num", "aria-hidden": "true", children: h ? "✓" : c + 1 }),
            s.label
          ]
        },
        s.label
      );
    }) }),
    /* @__PURE__ */ e(
      "div",
      {
        className: "shdcfg-stepper-track",
        role: "progressbar",
        "aria-valuenow": Math.round(r),
        "aria-valuemin": 0,
        "aria-valuemax": 100,
        "aria-label": "Overall progress",
        children: /* @__PURE__ */ e("div", { className: "shdcfg-stepper-fill", style: { width: `${r}%` } })
      }
    )
  ] });
}
function j() {
  const { state: t, config: r } = b(), s = N(t, r);
  return /* @__PURE__ */ d("div", { className: "shdcfg-ticket", children: [
    /* @__PURE__ */ d("div", { className: "shdcfg-ticket-title", children: [
      /* @__PURE__ */ e("span", { children: "Your quote" }),
      /* @__PURE__ */ d("span", { "aria-hidden": "true", children: [
        "№ ",
        r.version
      ] })
    ] }),
    s.lineItems.length === 0 ? /* @__PURE__ */ e("p", { className: "shdcfg-ticket-hint", children: "Pick a shed model and size to start your quote." }) : /* @__PURE__ */ e("ul", { className: "shdcfg-ticket-rows", children: s.lineItems.map((c) => /* @__PURE__ */ d(
      "li",
      {
        className: `shdcfg-ticket-row${c.included ? " is-included" : ""}`,
        children: [
          /* @__PURE__ */ d("span", { children: [
            c.label,
            /* @__PURE__ */ e("span", { className: "shdcfg-ticket-detail", children: c.detail })
          ] }),
          /* @__PURE__ */ e("span", { className: "shdcfg-ticket-price", children: c.stepId === "model" ? "—" : c.included ? "Included" : c.price })
        ]
      },
      c.stepId
    )) }),
    /* @__PURE__ */ d("div", { className: "shdcfg-ticket-total", children: [
      /* @__PURE__ */ e("span", { children: "Total" }),
      /* @__PURE__ */ e("strong", { children: I(s.totalCents) })
    ] }),
    /* @__PURE__ */ e("p", { className: "shdcfg-ticket-hint", children: "Prices update live as you make selections." })
  ] });
}
function ie() {
  return /* @__PURE__ */ e("aside", { className: "shdcfg-rail", "aria-label": "Running price summary", children: /* @__PURE__ */ e(j, {}) });
}
function oe() {
  const { state: t, config: r } = b(), s = N(t, r);
  return /* @__PURE__ */ d("details", { className: "shdcfg-drawer", children: [
    /* @__PURE__ */ d("summary", { children: [
      /* @__PURE__ */ e("span", { children: "Price summary" }),
      /* @__PURE__ */ e("span", { children: I(s.totalCents) })
    ] }),
    /* @__PURE__ */ e(j, {})
  ] });
}
function k({ heading: t, subheading: r, children: s }) {
  return /* @__PURE__ */ d("section", { children: [
    /* @__PURE__ */ e("h2", { className: "shdcfg-step-heading", children: t }),
    r && /* @__PURE__ */ e("p", { className: "shdcfg-step-sub", children: r }),
    s
  ] });
}
function ne() {
  var i;
  const { state: t, dispatch: r, config: s } = b(), c = t.modelLocked && t.dimensionsLocked;
  if (C(() => {
    if (!t.modelLocked && !t.model) {
      const o = t.dimensions, a = (n) => {
        var l, p;
        return o != null && ((p = (l = s.basePrices) == null ? void 0 : l[n]) == null ? void 0 : p[`${o.w}x${o.l}`]) != null;
      }, h = s.models.find((n) => a(n.id)) ?? s.models.find((n) => n.id === "utility") ?? s.models[0];
      h && r({ type: "SELECT_MODEL", model: h.id });
    }
  }, [t.model, t.modelLocked, t.dimensions, s.models, s.basePrices, r]), c && t.model && t.dimensions) {
    const o = ((i = s.models.find((a) => a.id === t.model)) == null ? void 0 : i.name) ?? t.model;
    return /* @__PURE__ */ e(k, { heading: "Confirm your shed.", children: /* @__PURE__ */ d("div", { className: "shdcfg-confirm", children: [
      /* @__PURE__ */ e("span", { className: "shdcfg-confirm-art", children: /* @__PURE__ */ e(F, { kind: "shed" }) }),
      /* @__PURE__ */ d("div", { children: [
        /* @__PURE__ */ d("p", { className: "shdcfg-confirm-title", children: [
          "You're configuring: ",
          t.dimensions.w,
          "×",
          t.dimensions.l,
          " ",
          o
        ] }),
        /* @__PURE__ */ e("p", { className: "shdcfg-confirm-note", children: "Picked on the product page — press Continue to start choosing options." })
      ] })
    ] }) });
  }
  return /* @__PURE__ */ e(
    k,
    {
      heading: v.model,
      subheading: "Pick the size that fits — it drives square-footage pricing for the steps that follow.",
      children: /* @__PURE__ */ e(ce, {})
    }
  );
}
function ce() {
  var f;
  const { state: t, dispatch: r, config: s } = b();
  if (t.dimensionsLocked && t.dimensions)
    return /* @__PURE__ */ d(u, { children: [
      /* @__PURE__ */ e("h3", { className: "shdcfg-section-label", children: "Size" }),
      /* @__PURE__ */ d("p", { className: "shdcfg-confirm-note", children: [
        t.dimensions.w,
        "×",
        t.dimensions.l,
        " ft — locked by the page you came from."
      ] })
    ] });
  const c = t.model ? (f = s.basePrices) == null ? void 0 : f[t.model] : void 0, i = c ? s.sizes.filter((g) => c[`${g.w}x${g.l}`] != null) : s.sizes, o = i.length > 0 ? i : s.sizes, a = [], h = o.findIndex(
    (g) => {
      var x, y;
      return g.w === ((x = t.dimensions) == null ? void 0 : x.w) && g.l === ((y = t.dimensions) == null ? void 0 : y.l);
    }
  ), n = Math.max(0, h), l = (g) => r({ type: "SELECT_SIZE", dimensions: o[g] }), p = (g, x) => {
    var m;
    const y = (g + x + o.length) % o.length;
    (m = a[y]) == null || m.focus(), l(y);
  };
  return /* @__PURE__ */ d(u, { children: [
    /* @__PURE__ */ e("h3", { className: "shdcfg-section-label", children: "Size (W × L, feet)" }),
    /* @__PURE__ */ e("div", { className: "shdcfg-chips", role: "radiogroup", "aria-label": "Shed size", children: o.map((g, x) => {
      const y = x === h;
      return /* @__PURE__ */ d(
        "button",
        {
          ref: (m) => {
            a[x] = m;
          },
          type: "button",
          role: "radio",
          "aria-checked": y,
          tabIndex: x === n ? 0 : -1,
          className: `shdcfg-chip${y ? " is-selected" : ""}`,
          onClick: () => l(x),
          onKeyDown: (m) => {
            m.key === "ArrowRight" || m.key === "ArrowDown" ? (m.preventDefault(), p(x, 1)) : m.key === "ArrowLeft" || m.key === "ArrowUp" ? (m.preventDefault(), p(x, -1)) : (m.key === " " || m.key === "Enter") && (m.preventDefault(), l(x));
          },
          children: [
            g.w,
            "×",
            g.l
          ]
        },
        `${g.w}x${g.l}`
      );
    }) })
  ] });
}
const ae = X(function({ option: r, selected: s, tabIndex: c, onSelect: i, onKeyDown: o }, a) {
  const h = !!r.included;
  return /* @__PURE__ */ d(
    "div",
    {
      ref: a,
      role: "radio",
      "aria-checked": s,
      "aria-label": `${r.title}, ${r.included ? "included" : r.priceLabel}`,
      tabIndex: c,
      className: `shdcfg-card${s ? " is-selected" : ""}${h ? " is-locked" : ""}`,
      onClick: i,
      onKeyDown: o,
      children: [
        /* @__PURE__ */ e("div", { className: "shdcfg-card-media", children: /* @__PURE__ */ e(F, { kind: r.art }) }),
        /* @__PURE__ */ d("div", { className: "shdcfg-card-body", children: [
          r.includedLabel && /* @__PURE__ */ e("span", { className: "shdcfg-card-included-badge", children: r.includedLabel }),
          /* @__PURE__ */ e("span", { className: "shdcfg-card-title", children: r.title }),
          r.specNote && /* @__PURE__ */ e("span", { className: "shdcfg-card-note", children: r.specNote }),
          /* @__PURE__ */ e("span", { className: "shdcfg-card-price", children: r.priceLabel })
        ] }),
        /* @__PURE__ */ e("span", { className: "shdcfg-check", "aria-hidden": "true", children: /* @__PURE__ */ e(D, {}) })
      ]
    }
  );
});
function E({ options: t, selectedId: r, onSelect: s, ariaLabel: c }) {
  const i = z([]), o = r != null ? Math.max(
    0,
    t.findIndex((n) => n.id === r)
  ) : 0, a = (n, l) => {
    var g;
    const p = (n + l + t.length) % t.length, f = t[p];
    (g = i.current[p]) == null || g.focus(), f.included || s(f);
  }, h = (n) => (l) => {
    switch (l.key) {
      case "ArrowRight":
      case "ArrowDown":
        l.preventDefault(), a(n, 1);
        break;
      case "ArrowLeft":
      case "ArrowUp":
        l.preventDefault(), a(n, -1);
        break;
      case " ":
      case "Enter":
        l.preventDefault(), t[n].included || s(t[n]);
        break;
    }
  };
  return /* @__PURE__ */ e("div", { className: "shdcfg-options", role: "radiogroup", "aria-label": c, children: t.map((n, l) => /* @__PURE__ */ e(
    ae,
    {
      ref: (p) => {
        i.current[l] = p;
      },
      option: n,
      selected: n.id === r,
      tabIndex: l === o ? 0 : -1,
      onSelect: () => {
        n.included || s(n);
      },
      onKeyDown: h(l)
    },
    n.id
  )) });
}
function B({ swatches: t, selectedId: r, onSelect: s, ariaLabel: c }) {
  const i = z([]), o = r != null ? Math.max(
    0,
    t.findIndex((n) => n.id === r)
  ) : 0, a = (n, l) => {
    var f;
    const p = (n + l + t.length) % t.length;
    (f = i.current[p]) == null || f.focus(), s(t[p]);
  }, h = (n) => (l) => {
    switch (l.key) {
      case "ArrowRight":
      case "ArrowDown":
        l.preventDefault(), a(n, 1);
        break;
      case "ArrowLeft":
      case "ArrowUp":
        l.preventDefault(), a(n, -1);
        break;
      case " ":
      case "Enter":
        l.preventDefault(), s(t[n]);
        break;
    }
  };
  return /* @__PURE__ */ e("div", { className: "shdcfg-swatches", role: "radiogroup", "aria-label": c, children: t.map((n, l) => {
    const p = n.id === r;
    return /* @__PURE__ */ d(
      "button",
      {
        ref: (f) => {
          i.current[l] = f;
        },
        type: "button",
        role: "radio",
        "aria-checked": p,
        tabIndex: l === o ? 0 : -1,
        className: `shdcfg-swatch${p ? " is-selected" : ""}`,
        onClick: () => s(n),
        onKeyDown: h(l),
        children: [
          /* @__PURE__ */ e("span", { className: "shdcfg-swatch-chip", style: { background: n.hex, display: "block" } }),
          /* @__PURE__ */ e("span", { className: "shdcfg-swatch-label", children: n.name }),
          /* @__PURE__ */ e("span", { className: "shdcfg-check", "aria-hidden": "true", children: /* @__PURE__ */ e(D, {}) })
        ]
      },
      n.id
    );
  }) });
}
function le() {
  var h;
  const { state: t, dispatch: r, config: s } = b(), c = M("paint", t, s), i = t.selections.paint, o = c.find((n) => n.id === (i == null ? void 0 : i.optionId)), a = !!(o != null && o.requiresColor) && (((h = o.colorChoices) == null ? void 0 : h.length) ?? 0) > 0;
  return C(() => {
    i || r({ type: "SELECT_OPTION", stepId: "paint", optionId: "none" });
  }, [i, r]), /* @__PURE__ */ d(
    k,
    {
      heading: v.paint,
      subheading: "Rates apply to your shed's paintable wall area.",
      children: [
        /* @__PURE__ */ e(
          E,
          {
            options: c,
            selectedId: (i == null ? void 0 : i.optionId) ?? null,
            ariaLabel: v.paint,
            onSelect: (n) => r({ type: "SELECT_OPTION", stepId: "paint", optionId: n.id })
          }
        ),
        a && /* @__PURE__ */ d(u, { children: [
          /* @__PURE__ */ e("h3", { className: "shdcfg-section-label", children: "Choose your color" }),
          /* @__PURE__ */ e(
            B,
            {
              swatches: o.colorChoices,
              selectedId: (i == null ? void 0 : i.color) ?? null,
              ariaLabel: "Paint color",
              onSelect: (n) => r({ type: "SELECT_COLOR", stepId: "paint", colorId: n.id })
            }
          )
        ] })
      ]
    }
  );
}
function he() {
  var n;
  const { state: t, dispatch: r, config: s } = b(), c = M("loft", t, s), i = O("loft", t, s), o = G(t, s), a = c.find((l) => l.id === "loft"), h = (a == null ? void 0 : a.requiresDepth) && (i == null ? void 0 : i.optionId) === "loft";
  return /* @__PURE__ */ d(k, { heading: v.loft, subheading: "Overhead storage above the walls.", children: [
    /* @__PURE__ */ e(
      E,
      {
        options: c,
        selectedId: (i == null ? void 0 : i.optionId) ?? null,
        ariaLabel: v.loft,
        onSelect: (l) => r({
          type: "SELECT_OPTION",
          stepId: "loft",
          optionId: l.id,
          depthFt: l.depthFt
        })
      }
    ),
    h && /* @__PURE__ */ d(u, { children: [
      /* @__PURE__ */ e("h3", { className: "shdcfg-section-label", children: "Loft depth" }),
      /* @__PURE__ */ e("div", { className: "shdcfg-chips", role: "radiogroup", "aria-label": "Loft depth in feet", children: (n = a.depthChoicesFt) == null ? void 0 : n.map((l) => {
        var f;
        const p = ((f = t.selections.loft) == null ? void 0 : f.depthFt) === l;
        return /* @__PURE__ */ d(
          "button",
          {
            type: "button",
            role: "radio",
            "aria-checked": p,
            className: `shdcfg-chip${p ? " is-selected" : ""}`,
            onClick: () => r({ type: "SELECT_OPTION", stepId: "loft", optionId: "loft", depthFt: l }),
            children: [
              l,
              " ft"
            ]
          },
          l
        );
      }) })
    ] }),
    o && /* @__PURE__ */ d("p", { className: "shdcfg-constraint", children: [
      /* @__PURE__ */ e("span", { "aria-hidden": "true", children: "ⓘ" }),
      " Loft depth limited to ",
      o.shortestWallFt,
      " ft (your shortest wall)."
    ] })
  ] });
}
function fe() {
  const { state: t, dispatch: r, config: s } = b(), c = M("shelving", t, s), i = O("shelving", t, s), o = s.shelving.allowQuantity && (i == null ? void 0 : i.optionId) === "shelving";
  return /* @__PURE__ */ d(k, { heading: v.shelving, children: [
    /* @__PURE__ */ e(
      E,
      {
        options: c,
        selectedId: (i == null ? void 0 : i.optionId) ?? null,
        ariaLabel: v.shelving,
        onSelect: (a) => r({ type: "SELECT_OPTION", stepId: "shelving", optionId: a.id })
      }
    ),
    o && /* @__PURE__ */ d(u, { children: [
      /* @__PURE__ */ e("h3", { className: "shdcfg-section-label", children: "How many? (one per side)" }),
      /* @__PURE__ */ e("div", { className: "shdcfg-chips", role: "radiogroup", "aria-label": "Shelving quantity", children: Array.from({ length: s.shelving.maxQuantity }, (a, h) => h + 1).map((a) => {
        var n;
        const h = (((n = t.selections.shelving) == null ? void 0 : n.quantity) ?? 1) === a;
        return /* @__PURE__ */ e(
          "button",
          {
            type: "button",
            role: "radio",
            "aria-checked": h,
            className: `shdcfg-chip${h ? " is-selected" : ""}`,
            onClick: () => r({ type: "SET_QUANTITY", stepId: "shelving", quantity: a }),
            children: a
          },
          a
        );
      }) })
    ] })
  ] });
}
function pe() {
  const { state: t, dispatch: r, config: s } = b(), c = M("roofing", t, s), i = t.selections.roofing, o = c.find((n) => n.id === (i == null ? void 0 : i.optionId)), a = (o == null ? void 0 : o.colorChoices) ?? [], h = a.length > 0;
  return /* @__PURE__ */ d(k, { heading: v.roofing, children: [
    /* @__PURE__ */ e(
      E,
      {
        options: c,
        selectedId: (i == null ? void 0 : i.optionId) ?? null,
        ariaLabel: v.roofing,
        onSelect: (n) => r({ type: "SELECT_OPTION", stepId: "roofing", optionId: n.id })
      }
    ),
    h && /* @__PURE__ */ d(u, { children: [
      /* @__PURE__ */ e("h3", { className: "shdcfg-section-label", children: "Shingle color" }),
      /* @__PURE__ */ e(
        B,
        {
          swatches: a,
          selectedId: (i == null ? void 0 : i.color) ?? null,
          ariaLabel: "Shingle color",
          onSelect: (n) => r({ type: "SELECT_COLOR", stepId: "roofing", colorId: n.id })
        }
      )
    ] })
  ] });
}
const ge = [
  { field: "firstName", label: "First Name", type: "text", autoComplete: "given-name" },
  { field: "lastName", label: "Last Name", type: "text", autoComplete: "family-name" },
  { field: "email", label: "Email", type: "email", autoComplete: "email", wide: !0 },
  { field: "phone", label: "Phone", type: "tel", autoComplete: "tel" },
  { field: "zip", label: "ZIP Code", type: "text", autoComplete: "postal-code" }
];
function ue({ submitting: t, submitError: r, onSubmit: s }) {
  const { state: c, dispatch: i } = b();
  return /* @__PURE__ */ d("form", { className: "shdcfg-form", onSubmit: s, noValidate: !0, children: [
    /* @__PURE__ */ e("h3", { className: "shdcfg-form-title", children: "Reserve your build" }),
    /* @__PURE__ */ e("p", { className: "shdcfg-form-sub", children: "Enter your details to continue to secure checkout." }),
    /* @__PURE__ */ e("div", { className: "shdcfg-form-grid", children: ge.map(({ field: o, label: a, type: h, autoComplete: n, wide: l }) => {
      const p = c.leadErrors[o], f = `shdcfg-lead-${o}`;
      return /* @__PURE__ */ d(
        "div",
        {
          className: `shdcfg-field${l ? " is-wide" : ""}${p ? " has-error" : ""}`,
          children: [
            /* @__PURE__ */ d("label", { htmlFor: f, children: [
              a,
              " *"
            ] }),
            /* @__PURE__ */ e(
              "input",
              {
                id: f,
                type: h,
                autoComplete: n,
                required: !0,
                value: c.lead[o],
                "aria-invalid": !!p,
                "aria-describedby": p ? `${f}-error` : void 0,
                onChange: (g) => i({ type: "SET_LEAD_FIELD", field: o, value: g.target.value }),
                onBlur: () => i({ type: "BLUR_LEAD_FIELD", field: o })
              }
            ),
            p && /* @__PURE__ */ e("span", { className: "shdcfg-field-error", id: `${f}-error`, role: "alert", children: p })
          ]
        },
        o
      );
    }) }),
    r && /* @__PURE__ */ e("p", { className: "shdcfg-error", role: "alert", children: r }),
    /* @__PURE__ */ e("button", { type: "submit", className: "shdcfg-btn shdcfg-btn-primary", "aria-disabled": t, children: t ? "Opening checkout…" : "Continue to Secure Checkout" }),
    /* @__PURE__ */ e("p", { className: "shdcfg-form-disclaimer", children: "Secure payment powered by Stripe — a deposit reserves your build." }),
    /* @__PURE__ */ d("div", { className: "shdcfg-phone-callout", children: [
      /* @__PURE__ */ e("span", { className: "shdcfg-phone-callout-label", children: "Questions before you pay your deposit? Give us a call:" }),
      /* @__PURE__ */ e("a", { href: "tel:+16822040561", className: "shdcfg-phone-callout-number", children: "(682) 204-0561" })
    ] })
  ] });
}
function me({ onQuoteSubmit: t }) {
  const { state: r, dispatch: s, config: c } = b(), i = N(r, c), [o, a] = _(!1), [h, n] = _(null), l = (f) => f !== "model" || !(r.modelLocked && r.dimensionsLocked), p = async (f) => {
    if (f.preventDefault(), o || (s({ type: "SUBMIT_ATTEMPT" }), Object.keys(Q(r.lead)).length > 0)) return;
    const g = H(r, c, (/* @__PURE__ */ new Date()).toISOString());
    n(null), a(!0);
    try {
      await t(g), s({ type: "SUBMIT_SUCCESS" });
    } catch {
      n("We couldn't open checkout. Please try again.");
    } finally {
      a(!1);
    }
  };
  return /* @__PURE__ */ d(
    k,
    {
      heading: v.quote,
      subheading: "Review every selection — use Edit to change anything. Your other choices are preserved.",
      children: [
        /* @__PURE__ */ e("ul", { className: "shdcfg-quote-list", children: i.lineItems.map((f) => /* @__PURE__ */ d("li", { className: "shdcfg-quote-item", children: [
          /* @__PURE__ */ e("span", { className: "shdcfg-quote-item-label", children: f.label }),
          /* @__PURE__ */ e("span", { className: "shdcfg-quote-item-detail", children: f.detail }),
          /* @__PURE__ */ e(
            "span",
            {
              className: `shdcfg-quote-item-price${f.included ? " is-included" : ""}`,
              children: f.stepId === "model" ? "—" : f.included ? "Included — $0.00" : f.price
            }
          ),
          l(f.stepId) && /* @__PURE__ */ e(
            "button",
            {
              type: "button",
              className: "shdcfg-edit-link",
              onClick: () => s({ type: "EDIT_STEP", stepId: f.stepId }),
              "aria-label": `Edit ${f.label}`,
              children: "Edit"
            }
          )
        ] }, f.stepId)) }),
        /* @__PURE__ */ d("div", { className: "shdcfg-quote-grand", children: [
          /* @__PURE__ */ e("span", { children: "Grand total" }),
          /* @__PURE__ */ e("strong", { children: I(i.totalCents) })
        ] }),
        /* @__PURE__ */ e(ue, { submitting: o, submitError: h, onSubmit: p })
      ]
    }
  );
}
function w({ stepId: t, subheading: r }) {
  const { state: s, dispatch: c, config: i } = b(), o = M(t, s, i), a = O(t, s, i);
  return /* @__PURE__ */ e(k, { heading: v[t], subheading: r, children: /* @__PURE__ */ e(
    E,
    {
      options: o,
      selectedId: (a == null ? void 0 : a.optionId) ?? null,
      ariaLabel: v[t],
      onSelect: (h) => c({ type: "SELECT_OPTION", stepId: t, optionId: h.id, depthFt: h.depthFt })
    }
  ) });
}
const xe = `
.shdcfg{
  --shdcfg-primary:#1B6FE8;
  --shdcfg-radius:10px;
  --shdcfg-font:'Avenir Next','Seravek','Gill Sans',ui-sans-serif,system-ui,'Segoe UI',sans-serif;
  --shdcfg-text:#0f172a;
  --shdcfg-muted:#64748b;
  --shdcfg-border:#e2e8f0;
  --shdcfg-surface:#ffffff;
  --shdcfg-bg:#ffffff;
  --shdcfg-success:#176f44;
  --shdcfg-danger:#b3261e;

  font-family:var(--shdcfg-font);
  color:var(--shdcfg-text);
  font-size:16px;
  line-height:1.45;
  box-sizing:border-box;
  background:var(--shdcfg-bg);
  border:1px solid var(--shdcfg-border);
  border-radius:calc(var(--shdcfg-radius) + 6px);
  padding:clamp(14px,3vw,26px);
  font-variant-numeric:tabular-nums;
  -webkit-font-smoothing:antialiased;
}
.shdcfg *,.shdcfg *::before,.shdcfg *::after{box-sizing:inherit;margin:0;padding:0;font:inherit;color:inherit}
.shdcfg button{background:none;border:none;cursor:pointer;text-align:inherit}
.shdcfg :focus{outline:none}
.shdcfg :focus-visible{outline:3px solid var(--shdcfg-primary);outline-offset:2px;border-radius:4px}
.shdcfg-sr-only{position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0 0 0 0);white-space:nowrap;border:0}

/* ---------- Stepper ---------- */
.shdcfg-stepper{margin-bottom:20px}
.shdcfg-stepper-groups{display:flex;gap:4px;list-style:none;flex-wrap:wrap;margin-bottom:10px}
.shdcfg-stepper-group{display:flex;align-items:center;gap:7px;padding:6px 12px 6px 7px;border-radius:999px;font-size:13.5px;color:var(--shdcfg-muted);letter-spacing:.01em}
.shdcfg-stepper-group .shdcfg-stepper-num{display:inline-flex;align-items:center;justify-content:center;width:22px;height:22px;border-radius:50%;border:1.5px solid var(--shdcfg-border);background:var(--shdcfg-surface);font-size:12px;font-weight:700}
.shdcfg-stepper-group.is-done{color:var(--shdcfg-text)}
.shdcfg-stepper-group.is-done .shdcfg-stepper-num{background:var(--shdcfg-primary);border-color:var(--shdcfg-primary);color:#fff}
.shdcfg-stepper-group.is-current{color:var(--shdcfg-text);font-weight:700;background:var(--shdcfg-surface);box-shadow:0 1px 3px rgba(20,30,40,.08)}
.shdcfg-stepper-group.is-current .shdcfg-stepper-num{border-color:var(--shdcfg-primary);color:var(--shdcfg-primary)}
.shdcfg-stepper-track{height:6px;border-radius:999px;background:var(--shdcfg-border);overflow:hidden}
.shdcfg-stepper-fill{height:100%;border-radius:999px;background:var(--shdcfg-primary);transition:width .35s ease}

/* ---------- Layout ---------- */
.shdcfg-layout{display:grid;grid-template-columns:minmax(0,1fr) 330px;gap:24px;align-items:start}
.shdcfg-main{min-width:0}
.shdcfg-step-heading{font-size:clamp(21px,3vw,26px);font-weight:800;letter-spacing:-.01em;margin:2px 0 4px}
.shdcfg-step-sub{color:var(--shdcfg-muted);font-size:14.5px;margin-bottom:18px}
.shdcfg-section-label{font-size:13px;font-weight:700;text-transform:uppercase;letter-spacing:.08em;color:var(--shdcfg-muted);margin:22px 0 10px}

/* ---------- Option cards ---------- */
.shdcfg-options{display:grid;grid-template-columns:repeat(auto-fill,minmax(225px,1fr));gap:14px}
.shdcfg-card{position:relative;display:flex;flex-direction:column;background:var(--shdcfg-surface);border:2px solid var(--shdcfg-border);border-radius:var(--shdcfg-radius);overflow:hidden;cursor:pointer;transition:border-color .15s ease,box-shadow .15s ease,transform .15s ease;text-align:left}
.shdcfg-card:hover{border-color:color-mix(in srgb,var(--shdcfg-primary) 55%,var(--shdcfg-border));box-shadow:0 4px 14px rgba(20,30,40,.08);transform:translateY(-1px)}
.shdcfg-card.is-selected{border-color:var(--shdcfg-primary);box-shadow:0 0 0 1px var(--shdcfg-primary),0 4px 14px rgba(20,30,40,.08)}
.shdcfg-card.is-locked{cursor:default;border-color:var(--shdcfg-primary);background:linear-gradient(180deg,color-mix(in srgb,var(--shdcfg-primary) 5%,var(--shdcfg-surface)),var(--shdcfg-surface))}
.shdcfg-card.is-locked:hover{transform:none;box-shadow:none}
.shdcfg-card-media{height:128px;display:flex;align-items:center;justify-content:center;background:repeating-linear-gradient(135deg,color-mix(in srgb,var(--shdcfg-primary) 6%,#f1f5f9),color-mix(in srgb,var(--shdcfg-primary) 6%,#f1f5f9) 14px,color-mix(in srgb,var(--shdcfg-primary) 10%,#f1f5f9) 14px,color-mix(in srgb,var(--shdcfg-primary) 10%,#f1f5f9) 28px);color:var(--shdcfg-primary)}
.shdcfg-card-photo{width:100%;height:100%;object-fit:cover;display:block}
/* Model-selection cards stand twice as tall as standard option cards. */
.shdcfg-options--model .shdcfg-card-media{height:184px}
.shdcfg-options--model .shdcfg-card-media svg{transform:scale(1.6)}
.shdcfg-card-body{display:flex;flex-direction:column;gap:5px;padding:13px 15px 15px;flex:1}
.shdcfg-card-title{font-weight:700;font-size:16.5px}
.shdcfg-card-note{color:var(--shdcfg-muted);font-size:13.5px}
.shdcfg-card-price{margin-top:auto;padding-top:8px;font-weight:700;font-size:14.5px}
.shdcfg-card-included-badge{display:inline-block;margin-bottom:2px;font-size:12.5px;font-weight:700;color:var(--shdcfg-success)}
.shdcfg-check{position:absolute;top:10px;right:10px;width:27px;height:27px;border-radius:50%;background:var(--shdcfg-primary);color:#fff;display:none;align-items:center;justify-content:center;box-shadow:0 1px 4px rgba(20,30,40,.25)}
.shdcfg-check svg{width:15px;height:15px}
.shdcfg-card.is-selected .shdcfg-check,.shdcfg-card.is-locked .shdcfg-check{display:flex}
.shdcfg-card.is-locked .shdcfg-check{background:var(--shdcfg-success)}

/* ---------- Swatches ---------- */
.shdcfg-swatches{display:grid;grid-template-columns:repeat(auto-fill,minmax(140px,1fr));gap:12px}
.shdcfg-swatch{position:relative;border:2px solid var(--shdcfg-border);border-radius:var(--shdcfg-radius);overflow:hidden;cursor:pointer;background:var(--shdcfg-surface);transition:border-color .15s ease,box-shadow .15s ease;padding:0;display:block;width:100%}
.shdcfg-swatch:hover{border-color:color-mix(in srgb,var(--shdcfg-primary) 55%,var(--shdcfg-border))}
.shdcfg-swatch.is-selected{border-color:var(--shdcfg-primary);box-shadow:0 0 0 1px var(--shdcfg-primary)}
.shdcfg-swatch-chip{height:62px}
.shdcfg-swatch-label{display:block;padding:7px 9px;font-size:13px;font-weight:600;border-top:1px solid var(--shdcfg-border);background:var(--shdcfg-surface);text-align:center}
.shdcfg-swatch .shdcfg-check{top:7px;right:7px;width:23px;height:23px}
.shdcfg-swatch.is-selected .shdcfg-check{display:flex}

/* ---------- Chips (loft depth, shelving qty) ---------- */
.shdcfg-chips{display:flex;gap:10px;flex-wrap:wrap}
.shdcfg-chip{padding:9px 18px;border-radius:999px;border:2px solid var(--shdcfg-border);background:var(--shdcfg-surface);font-weight:600;font-size:14.5px;cursor:pointer;transition:border-color .15s ease}
.shdcfg-chip:hover{border-color:color-mix(in srgb,var(--shdcfg-primary) 55%,var(--shdcfg-border))}
.shdcfg-chip.is-selected{border-color:var(--shdcfg-primary);background:color-mix(in srgb,var(--shdcfg-primary) 8%,var(--shdcfg-surface));color:var(--shdcfg-primary)}
.shdcfg-constraint{display:flex;gap:7px;align-items:baseline;margin:10px 0 0;font-size:13.5px;color:var(--shdcfg-muted)}

/* ---------- Nav / Continue bar ---------- */
.shdcfg-error{margin-top:14px;padding:11px 14px;border-radius:var(--shdcfg-radius);border:1px solid color-mix(in srgb,var(--shdcfg-danger) 35%,var(--shdcfg-border));background:color-mix(in srgb,var(--shdcfg-danger) 7%,var(--shdcfg-surface));color:var(--shdcfg-danger);font-size:14px;font-weight:600}
.shdcfg-nav{display:flex;align-items:center;gap:14px;margin-top:22px}
.shdcfg-btn{padding:13px 26px;border-radius:999px;font-weight:700;font-size:15.5px;letter-spacing:.01em;transition:opacity .15s ease,box-shadow .15s ease}
.shdcfg button.shdcfg-btn-primary{background:var(--shdcfg-primary);color:#fff;box-shadow:0 2px 8px color-mix(in srgb,var(--shdcfg-primary) 35%,transparent)}
.shdcfg-btn-primary:hover{box-shadow:0 4px 14px color-mix(in srgb,var(--shdcfg-primary) 45%,transparent)}
.shdcfg-btn-primary[aria-disabled="true"]{opacity:.45;cursor:not-allowed;box-shadow:none}
.shdcfg button.shdcfg-btn-ghost{border:2px solid var(--shdcfg-border);color:var(--shdcfg-text);background:var(--shdcfg-surface)}
.shdcfg-btn-ghost:disabled{opacity:.4;cursor:not-allowed}
.shdcfg-nav-total{margin-left:auto;font-size:14px;color:var(--shdcfg-muted);display:none}
.shdcfg-nav-total strong{display:block;font-size:18px;color:var(--shdcfg-text);font-weight:800}

/* ---------- Summary rail (quote ticket) ---------- */
.shdcfg-rail{position:sticky;top:16px}
.shdcfg-ticket{background:var(--shdcfg-surface);border:1px solid var(--shdcfg-border);border-radius:var(--shdcfg-radius);padding:18px 18px 14px;box-shadow:0 2px 10px rgba(20,30,40,.05)}
.shdcfg-ticket-title{font-size:13px;font-weight:800;text-transform:uppercase;letter-spacing:.1em;color:var(--shdcfg-muted);margin-bottom:12px;display:flex;justify-content:space-between;align-items:center}
.shdcfg-ticket-rows{list-style:none;display:flex;flex-direction:column;gap:9px}
.shdcfg-ticket-row{display:flex;justify-content:space-between;gap:12px;font-size:13.5px;align-items:baseline}
.shdcfg-ticket-row .shdcfg-ticket-detail{color:var(--shdcfg-muted);display:block;font-size:12.5px}
.shdcfg-ticket-row.is-included .shdcfg-ticket-price{color:var(--shdcfg-success);font-weight:700}
.shdcfg-ticket-price{white-space:nowrap;font-weight:600}
.shdcfg-ticket-total{display:flex;justify-content:space-between;align-items:baseline;margin-top:14px;padding-top:13px;border-top:2px dashed var(--shdcfg-border);font-weight:800;font-size:15px}
.shdcfg-ticket-total strong{font-size:21px;letter-spacing:-.01em}
.shdcfg-ticket-hint{margin-top:10px;font-size:12px;color:var(--shdcfg-muted)}
.shdcfg-drawer{display:none;margin-bottom:14px;border:1px solid var(--shdcfg-border);border-radius:var(--shdcfg-radius);background:var(--shdcfg-surface)}
.shdcfg-drawer>summary{cursor:pointer;padding:12px 14px;font-weight:700;font-size:14.5px;display:flex;justify-content:space-between;list-style:none}
.shdcfg-drawer>summary::-webkit-details-marker{display:none}
.shdcfg-drawer .shdcfg-ticket{border:none;box-shadow:none;padding-top:2px}

/* ---------- Quote summary table ---------- */
.shdcfg-quote-list{list-style:none;background:var(--shdcfg-surface);border:1px solid var(--shdcfg-border);border-radius:var(--shdcfg-radius);overflow:hidden;margin-bottom:8px}
.shdcfg-quote-item{display:flex;align-items:center;gap:14px;padding:13px 16px;border-bottom:1px solid var(--shdcfg-border)}
.shdcfg-quote-item:last-child{border-bottom:none}
.shdcfg-quote-item-label{font-size:12.5px;font-weight:700;text-transform:uppercase;letter-spacing:.07em;color:var(--shdcfg-muted);width:118px;flex-shrink:0}
.shdcfg-quote-item-detail{flex:1;font-size:14.5px;min-width:0}
.shdcfg-quote-item-price{font-weight:700;white-space:nowrap}
.shdcfg-quote-item-price.is-included{color:var(--shdcfg-success)}
.shdcfg-edit-link{color:var(--shdcfg-primary);font-weight:700;font-size:13.5px;text-decoration:underline;text-underline-offset:2px;flex-shrink:0}
.shdcfg-quote-grand{display:flex;justify-content:flex-end;gap:18px;align-items:baseline;padding:14px 16px;font-weight:800;font-size:16px}
.shdcfg-quote-grand strong{font-size:24px;letter-spacing:-.01em}

/* ---------- Lead form ---------- */
.shdcfg-form{margin-top:24px;background:var(--shdcfg-surface);border:1px solid var(--shdcfg-border);border-radius:var(--shdcfg-radius);padding:20px}
.shdcfg-form-title{font-weight:800;font-size:18px;margin-bottom:4px}
.shdcfg-form-sub{color:var(--shdcfg-muted);font-size:13.5px;margin-bottom:16px}
.shdcfg-form-grid{display:grid;grid-template-columns:1fr 1fr;gap:14px}
.shdcfg-field{display:flex;flex-direction:column;gap:5px}
.shdcfg-field.is-wide{grid-column:1/-1}
.shdcfg-field label{font-size:13px;font-weight:700}
.shdcfg-field input{padding:11px 13px;border:1.5px solid var(--shdcfg-border);border-radius:calc(var(--shdcfg-radius) - 3px);background:var(--shdcfg-surface);font-size:15px;width:100%}
.shdcfg-field input:focus-visible{outline-width:2px;outline-offset:0;border-color:var(--shdcfg-primary)}
.shdcfg-field.has-error input{border-color:var(--shdcfg-danger)}
.shdcfg-field-error{font-size:12.5px;color:var(--shdcfg-danger);font-weight:600}
.shdcfg-form .shdcfg-btn{margin-top:18px;width:100%}
.shdcfg-form-disclaimer{margin-top:10px;font-size:12px;color:var(--shdcfg-muted);text-align:center}
.shdcfg-phone-callout{margin-top:16px;padding:14px 16px;border:2px solid var(--shdcfg-primary);border-radius:var(--shdcfg-radius);text-align:center;display:flex;flex-direction:column;gap:4px}
.shdcfg-phone-callout-label{font-size:13.5px;font-weight:700}
.shdcfg-phone-callout-number{font-size:28px;font-weight:900;letter-spacing:.01em;color:var(--shdcfg-primary);text-decoration:none;white-space:nowrap}
.shdcfg-phone-callout-number:hover{text-decoration:underline}

/* ---------- Success ---------- */
.shdcfg-success{background:var(--shdcfg-surface);border:1px solid var(--shdcfg-border);border-radius:var(--shdcfg-radius);padding:38px 26px;text-align:center}
.shdcfg-success-icon{width:54px;height:54px;border-radius:50%;background:var(--shdcfg-success);color:#fff;display:inline-flex;align-items:center;justify-content:center;margin-bottom:14px}
.shdcfg-success-icon svg{width:26px;height:26px}
.shdcfg-success h3{font-size:22px;font-weight:800;margin-bottom:6px}
.shdcfg-success p{color:var(--shdcfg-muted);font-size:14.5px;max-width:42ch;margin:0 auto 6px}
.shdcfg-success .shdcfg-btn{margin-top:16px}

/* ---------- Read-only confirmation card (prop-driven Step 0) ---------- */
.shdcfg-confirm{display:flex;gap:16px;align-items:center;background:var(--shdcfg-surface);border:2px solid var(--shdcfg-primary);border-radius:var(--shdcfg-radius);padding:18px 20px;max-width:560px}
.shdcfg-confirm-art{color:var(--shdcfg-primary);flex-shrink:0}
.shdcfg-confirm-title{font-weight:800;font-size:18px}
.shdcfg-confirm-note{color:var(--shdcfg-muted);font-size:13.5px}

/* ---------- Responsive ---------- */
/* Desktop: spread out — wider rail, bigger gaps, taller photos, denser grids. */
@media (min-width:1100px){
  .shdcfg{padding:32px 36px}
  .shdcfg-layout{grid-template-columns:minmax(0,1fr) 372px;gap:40px}
  .shdcfg-options{grid-template-columns:repeat(auto-fill,minmax(248px,1fr));gap:20px}
  .shdcfg-card-media{height:172px}
  .shdcfg-options--model .shdcfg-card-media{height:220px}
  .shdcfg-swatches{grid-template-columns:repeat(auto-fill,minmax(132px,1fr));gap:14px}
  .shdcfg-rail{top:24px}
  .shdcfg-ticket{padding:22px 22px 18px}
  .shdcfg-step-sub{font-size:15.5px;margin-bottom:24px}
}
@media (min-width:1500px){
  .shdcfg-options{grid-template-columns:repeat(auto-fill,minmax(270px,1fr))}
  .shdcfg-card-media{height:188px}
}
@media (max-width:900px){
  .shdcfg-layout{grid-template-columns:1fr}
  .shdcfg-rail{display:none}
  .shdcfg-drawer{display:block}
}
@media (max-width:640px){
  .shdcfg{padding:12px}
  .shdcfg-options{grid-template-columns:1fr}
  .shdcfg-swatches{grid-template-columns:repeat(2,minmax(0,1fr))}
  .shdcfg-form-grid{grid-template-columns:1fr}
  .shdcfg-nav{position:sticky;bottom:0;background:var(--shdcfg-bg);padding:12px 0;border-top:1px solid var(--shdcfg-border);z-index:3}
  .shdcfg-nav-total{display:block;text-align:right}
  .shdcfg-btn{padding:12px 20px}
  .shdcfg-quote-item{flex-wrap:wrap}
  .shdcfg-quote-item-label{width:100%}
}
@media (prefers-reduced-motion:reduce){
  .shdcfg *{transition:none!important;animation:none!important;scroll-behavior:auto!important}
}
`, R = "data-shdcfg";
function be(t) {
  if (typeof document > "u" && !t) return;
  const r = t ?? document;
  if (r.head.querySelector(`style[${R}]`)) return;
  const s = r.createElement("style");
  s.setAttribute(R, ""), s.textContent = xe, r.head.appendChild(s);
}
const T = "shdcfg:state:v1", ve = {
  primary: "--shdcfg-primary",
  radius: "--shdcfg-radius",
  font: "--shdcfg-font",
  text: "--shdcfg-text",
  muted: "--shdcfg-muted",
  border: "--shdcfg-border",
  surface: "--shdcfg-surface",
  bg: "--shdcfg-bg"
};
function ye(t) {
  const r = W({
    initialModel: t.initialModel,
    initialDimensions: t.initialDimensions
  });
  if (typeof window > "u") return r;
  try {
    const s = window.sessionStorage.getItem(T);
    if (!s) return r;
    const c = JSON.parse(s);
    return typeof (c == null ? void 0 : c.stepIndex) != "number" || typeof (c == null ? void 0 : c.selections) != "object" ? r : {
      ...r,
      ...c,
      model: r.modelLocked ? r.model : c.model,
      dimensions: r.dimensionsLocked ? r.dimensions : c.dimensions,
      modelLocked: r.modelLocked,
      dimensionsLocked: r.dimensionsLocked,
      submitted: !1,
      stepIndex: Math.min(c.stepIndex, S.length - 1)
    };
  } catch {
    return r;
  }
}
function we(t) {
  if (!(typeof window > "u"))
    try {
      t.submitted ? window.sessionStorage.removeItem(T) : window.sessionStorage.setItem(T, JSON.stringify(t));
    } catch {
    }
}
function Ee(t) {
  const { onStepChange: r, onQuoteSubmit: s } = t, c = L(
    () => Y(K, t.config),
    [t.config]
  ), i = L(() => V(c), [c]), [o, a] = ee(i, t, ye), h = z(null), n = z(!1);
  C(() => {
    var g;
    be((g = h.current) == null ? void 0 : g.ownerDocument);
  }, []), C(() => {
    we(o);
  }, [o]), C(() => {
    var g;
    if (!n.current) {
      n.current = !0;
      return;
    }
    r == null || r(S[o.stepIndex], o), (g = h.current) == null || g.scrollIntoView({ behavior: "smooth", block: "start" });
  }, [o.stepIndex]);
  const l = L(() => {
    var x;
    const g = {};
    for (const [y, m] of Object.entries(ve)) {
      const P = (x = t.theme) == null ? void 0 : x[y];
      P && (g[m] = P);
    }
    return g;
  }, [t.theme]), p = S[o.stepIndex], f = L(() => ({ state: o, dispatch: a, config: c }), [o, c]);
  return /* @__PURE__ */ e($.Provider, { value: f, children: /* @__PURE__ */ d("div", { className: "shdcfg", style: l, ref: h, children: [
    /* @__PURE__ */ e("span", { className: "shdcfg-sr-only", "aria-live": "polite", role: "status", children: o.submitted ? "Quote request sent." : `Step ${o.stepIndex + 1} of ${S.length}: ${v[p]}` }),
    /* @__PURE__ */ e(de, {}),
    /* @__PURE__ */ d("div", { className: "shdcfg-layout", children: [
      /* @__PURE__ */ d("main", { className: "shdcfg-main", children: [
        !o.submitted && /* @__PURE__ */ e(oe, {}),
        o.submitted ? /* @__PURE__ */ e(Ne, {}) : /* @__PURE__ */ d(u, { children: [
          ke(p, s),
          p !== "quote" && /* @__PURE__ */ e(re, {}),
          p === "quote" && /* @__PURE__ */ e(Se, {})
        ] })
      ] }),
      !o.submitted && /* @__PURE__ */ e(ie, {})
    ] })
  ] }) });
}
function ke(t, r) {
  switch (t) {
    case "model":
      return /* @__PURE__ */ e(ne, {});
    case "paint":
      return /* @__PURE__ */ e(le, {});
    case "flooring":
      return /* @__PURE__ */ e(w, { stepId: "flooring", subheading: "Priced against your shed's floor area." });
    case "foundation":
      return /* @__PURE__ */ e(w, { stepId: "foundation", subheading: "Unlevel sites are leveled with cinderblocks, priced per floor sq ft." });
    case "delivery":
      return /* @__PURE__ */ e(w, { stepId: "delivery", subheading: "Tell us if a fence headache board, gate, slope, or anything else could block the delivery truck." });
    case "anchors":
      return /* @__PURE__ */ e(w, { stepId: "anchors", subheading: "Auger anchors tie the shed down — recommended in high-wind areas." });
    case "ramp":
      return /* @__PURE__ */ e(w, { stepId: "ramp" });
    case "workbench":
      return /* @__PURE__ */ e(w, { stepId: "workbench" });
    case "loft":
      return /* @__PURE__ */ e(he, {});
    case "shelving":
      return /* @__PURE__ */ e(fe, {});
    case "venting":
      return /* @__PURE__ */ e(w, { stepId: "venting" });
    case "window":
      return /* @__PURE__ */ e(w, { stepId: "window" });
    case "roofing":
      return /* @__PURE__ */ e(pe, {});
    case "quote":
      return /* @__PURE__ */ e(me, { onQuoteSubmit: r });
    default:
      return null;
  }
}
function Se() {
  const t = b();
  return /* @__PURE__ */ d("div", { className: "shdcfg-nav", children: [
    /* @__PURE__ */ e(
      "button",
      {
        type: "button",
        className: "shdcfg-btn shdcfg-btn-ghost",
        onClick: () => t.dispatch({ type: "BACK_STEP" }),
        children: "Back"
      }
    ),
    /* @__PURE__ */ d("div", { className: "shdcfg-nav-total", children: [
      "Current total",
      /* @__PURE__ */ e("strong", { children: I(N(t.state, t.config).totalCents) })
    ] })
  ] });
}
function Ne() {
  const t = b(), r = I(N(t.state, t.config).totalCents);
  return /* @__PURE__ */ d("div", { className: "shdcfg-success", role: "status", children: [
    /* @__PURE__ */ e("span", { className: "shdcfg-success-icon", children: /* @__PURE__ */ e(D, {}) }),
    /* @__PURE__ */ e("h3", { children: "Your build is saved!" }),
    /* @__PURE__ */ d("p", { children: [
      "Your ",
      r,
      " shed configuration is saved. Finish in the secure checkout window to reserve it with a deposit — or start another build below."
    ] }),
    /* @__PURE__ */ e(
      "button",
      {
        type: "button",
        className: "shdcfg-btn shdcfg-btn-ghost",
        onClick: () => t.dispatch({ type: "RESET" }),
        children: "Configure another shed"
      }
    )
  ] });
}
export {
  Te as CONFIGURATOR_VERSION,
  Oe as MSG_SELECT_MODEL,
  De as MSG_SELECT_TO_CONTINUE,
  Pe as PRICED_STEPS,
  v as STEP_HEADINGS,
  qe as STEP_LABELS,
  S as STEP_ORDER,
  T as STORAGE_KEY,
  Ee as ShedConfigurator,
  _e as basePriceCents,
  H as buildQuotePayload,
  N as computeQuote,
  W as createInitialState,
  K as defaultConfig,
  G as derivedDimensions,
  Ae as floorSqFt,
  I as formatCents,
  O as getEffectiveSelection,
  Re as getInclusion,
  M as getStepOptions,
  $e as includedOptionId,
  U as isStepComplete,
  Fe as isUpgradeOptionId,
  je as loftPriceCents,
  Be as loftUpgradeDeltaCents,
  Y as mergeConfig,
  Ue as optionPriceCents,
  Ge as optionTitle,
  Qe as paintableSqFt,
  He as priceQuote,
  V as reduce,
  Ye as shortestWallFt,
  q as stepIndexOf,
  Q as validateLead,
  Ke as validateSelection
};
//# sourceMappingURL=index.js.map
